import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Control, Form, Errors} from 'react-redux-form';
import RegistrationAction from "../../actions/RegistrationAction";
import Modal from 'react-responsive-modal';
import preloader from '../../image/preloader.gif';

class Verify extends Component {

  state = {
    openModal: false
  };

  closeModal() {
    this.setState({
      openModal: false
    });
  }

  submit(data) {
    if (data.type === 'call') {
      this.setState({
        openModal: true
      });
    } else if (data.type === 'text') {
      this.props.sendCode(data.token);
    }
  }

  sendCall(data) {
    this.props.sendCall(data.extension, data.token);
  }

  render() {
    const {signVerifyForm, requestStatus} = this.props;
    return (
      <div className="row  signup-box">
        <div className="col-md-8 col-md-offset-2">
          <Form model="forms.signVerifyForm" className="sing-box" onSubmit={(data) => this.submit(data)}>
            <h1 className="text-center">Let's verify your business number </h1>
            <h4 className="text-center">We need to verify your association with this business</h4>
            <div className="mt10 center">
              <Control.radio model="forms.signVerifyForm.type"
                             className="inline" id="call" type="radio" name="type"
                             validators={{
                               required: (val) => val && val.length
                             }}
                             value="call"/>
              <div className="inline text">
                <label htmlFor="call">Call me at {signVerifyForm.phone} </label>
                <div>You'll get an automated call asking you to enter code.</div>
              </div>
            </div>
            <div className="center">
              <Control.radio model="forms.signVerifyForm.type"
                             className="inline" id="text" type="radio"
                             validators={{
                               required: (val) => val && val.length
                             }}
                             name="type" value="text"/>
              <div className="inline text">
                <label htmlFor="text">Text me at {signVerifyForm.phone} </label>
                <div>We'll automatically text you a code you can use to verify your business number.</div>
              </div>
            </div>
            <div className="center">
              <div className="error-box">
                <Errors
                  className="error"
                  model="forms.signVerifyForm.type"
                  show={(field) => field.submitFailed && !field.valid}
                  messages={{
                    required: 'Please select verify type'
                  }}
                />
              </div>
              <button disabled={requestStatus} type="submit" className="btn btn-action mt10">Verify</button>
              <img src={preloader} className={requestStatus && !this.state.openModal ? 'loader-button' : 'loader-button none'} alt="loading..." />
            </div>
          </Form>
          <Modal open={this.state.openModal} onClose={this.closeModal.bind(this)} little>
            <Form className="modal-sing" model="forms.signVerifyForm" onSubmit={(data) => this.sendCall(data)}>
              <h1 className="text-center">Provide Your Extension</h1>
              <h4 className="text-center">
                Does an automated phone system answer your calls? <br/>
                Provide your extension so we can reach you.
              </h4>
              <div className="mt10 center">
                <div className="inline text">
                  <label htmlFor="extension">{signVerifyForm.phone} x</label>
                </div>
                <Control.text type="number" placheholder="1234" model="forms.signVerifyForm.extension"
                              className="inline form-control" id="extension" name="extension"/>
              </div>
              <div className="center">
                <button disabled={requestStatus} type="submit" className="btn btn-action mt10">Call Me Now</button>
                <button type="submit" className="btn btn-default ml10 mt10"
                        onClick={this.closeModal.bind(this)}>Cancel
                </button>
                <img src={preloader} className={requestStatus ? 'loader-button' : 'loader-button none'} alt="loading..." />

              </div>
            </Form>
          </Modal>
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({
    currentStep: state.currentStep,
    requestStatus: state.requestStatus,
    signVerifyForm: state.forms.signVerifyForm
  }),
  dispatch => ({
    sendCall: (extension, token) => {
      dispatch(RegistrationAction.sendCall(extension, token));
    },
    sendCode: (token) => {
      dispatch(RegistrationAction.sendCode(token));
    }
  })
)(Verify);


/** WEBPACK FOOTER **
 ** ./src/components/Sign/verify.js
 **/